<script>
import textMixin from '~/mixins/textMixin'

export default {
  mixins: [textMixin],

  props: {
    tag: {
      type: String,
      default: 'h2',
      validator: (value) =>
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'].includes(value),
    },
  },

  computed: {
    classes() {
      return {
        BaseHeading: true,
        ...this.textClasses,
      }
    },
  },

  render() {
    return h(`${this.tag}`, { class: this.classes }, this.$slots.default())
  },
}
</script>
